/** VUEX Project manager
 *
 * @requires NextApiClient.js
 * @requires Project.js
 * @requires ProjectsAPI.js
 */

import { NextApiClient } from '@3cad/nextcore';

export const erpManager = {
    namespaced: true,
    state: {
        deliveries: null,
        campaigns: null,
        lists: null
    },
    getters: {
        deliveries: (state) => {
            return state.deliveries;
        },
        campaigns: (state) => {
            return state.campaigns;
        },
        lists: (state) => {
            return state.lists;
        }
    },
    mutations: {
        reset(state) {
            state.deliveries = null
            state.campaigns = null
            state.lists = null
        },
        setDeliveries(state, data) {
            if(data){
                state.deliveries = data.filter(obj => obj.cod !== '');
            }
        },
        setCampaigns(state, data) {
            if(data){
                state.campaigns = data.filter(obj => obj.cod !== '');
            }
        },
        setLists(state, data) {
            if(data){
                state.lists = data.filter(obj => obj.cod !== '');
            }
        }
    },
    actions: {
        update(context, { catalog, orderdate = '' }) {
            return new Promise( (resolve, reject) => {
                NextApiClient.com("e_promos", "jGetCatPromos", { Catalogo: catalog, orderdate: orderdate }, json => {
                    context.commit('setDeliveries', json.delivery);
                    context.commit('setCampaigns', json.campaign);
                    context.commit('setLists', json.list);
                    resolve(json);
                }, err => {
                    reject(err);
                })
            })
        }
    }
};



// WEBPACK FOOTER //
// ./src/_eng/store/erpStore.js